import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// project import x
import axios from 'utils/axios';

// types
import { MenuProps } from 'types/menu';

// initial state
const initialState: MenuProps = {
  openItem: ['dashboard'],
  openComponent: 'buttons',
  selectedID: null,
  drawerOpen: false,
  componentDrawerOpen: true,
  menu: {},
  error: null,
  projectCreator: false,
  projectMenu: [],
  conceptBeingEdited: {id: '', name: '', logs: [], markets: [], description: '', tagline: '', brainstorm: null, creationStage: '1'},
  activeMarket: { id: '', name: '', linkedMarkets: [], metadata: {createdAt: ''} },
  allMarkets: [],
  projectId: '',
  projectName: '',
  allowRegionsReset: false,
  specialAllowRegionsReset: false,
  isSizeWelcome: false,
  allConcepts: [],
  availableConcepts: [],
  openedProjectName: '',
  isBrainstormWelcome: false,
  openedProjectModules: [],
  activeStep: 0,
  isAiGenerate: false,
  segments: [],
  activeSubstep: 0,
  displayedResponses: [],
  modelConceptToShow: 0,
  displayData: [],
  displayData2: [],
  displayDataOriginal: [],
  displayData2Original: [],
  email: '',
  lockSexQueryBecauseOfSegmentNameChange: false,
  isResponseLoading: false,
  newExistingMarketAdding: false,
  isAnyStep2Behaviour: false,
  projectVariantChoiceStage: 0,
  population: null,
  nameEdit: '',
  nameEditTarget: ['', ''],
  locations: [],
  brainstormData: [],
  topPerformingConcepts: [],
};

// ==============================|| SLICE - MENU ||============================== //

export const fetchMenu = createAsyncThunk('', async () => {
  const response = await axios.get('/api/menu/dashboard');
  return response.data;
});

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeID(state, action) {
      state.selectedID = action.payload;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    },

    hasError(state, action) {
      state.error = action.payload;
    },

    openProjectCreator(state, action) {
      state.projectCreator = action.payload;
    },

    setProjectMenu(state, action) {
      state.projectMenu = action.payload;
    },

    setConceptBeingEdited(state, action) {
      state.conceptBeingEdited = action.payload;
    },

    setActiveMarket(state, action) {
      state.activeMarket = action.payload;
    },

    setAllMarkets(state, action) {
      state.allMarkets = action.payload;
    },

    setProjectId(state, action) {
      state.projectId = action.payload;
    },

    setProjectName(state, action) {
      state.projectName = action.payload;
    },

    setAllowRegionsReset(state, action) {
      state.allowRegionsReset = action.payload;
    },

    setSpecialAllowRegionsReset(state, action) {
      state.specialAllowRegionsReset = action.payload;
    },

    setIsSizeWelcome(state, action) {
      state.isSizeWelcome = action.payload;
    },

    setAllConcepts(state, action) {
      state.allConcepts = action.payload;
    },

    setAvailableConcepts(state, action) {
      state.availableConcepts = action.payload;
    },

    setOpenedProjectName(state, action) {
      state.openedProjectName = action.payload;
    },

    setIsBrainstormWelcome(state, action) {
      state.isBrainstormWelcome = action.payload;
    },

    setOpenedProjectModules(state, action) {
      state.openedProjectModules = action.payload;
    },

    setActiveStep(state, action) {
      state.activeStep = action.payload;
    },

    setIsAiGenerate(state, action) {
      state.isAiGenerate = action.payload;
    },

    setSegments(state, action) {
      state.segments = action.payload;
    },

    setActiveSubstep(state, action) {
      state.activeSubstep = action.payload;
    },

    setDisplayedResponses(state, action) {
      state.displayedResponses = action.payload;
    },

    setModelConceptToShow(state, action) {
      state.modelConceptToShow = action.payload;
    },

    setDisplayData(state, action) {
      state.displayData = action.payload;
    },

    setDisplayData2(state, action) {
      state.displayData2 = action.payload;
    },

    setDisplayData2Original(state, action) {
      state.displayData2Original = action.payload
    },

    setDisplayDataOriginal(state, action) {
      state.displayDataOriginal = action.payload
    },

    setEmail(state, action) {
      state.email = action.payload;
    },

    setLockSexQueryBecauseOfSegmentNameChange(state, action) {
      state.lockSexQueryBecauseOfSegmentNameChange = action.payload;
    },

    setIsResponseLoading(state, action) {
      state.isResponseLoading = action.payload;
    },

    setNewExistingMarketAdding(state, action) {
      state.newExistingMarketAdding = action.payload
    },

    setIsAnyStep2Behaviour(state, action) {
      state.isAnyStep2Behaviour = action.payload
    },

    setProjectVariantChoiceStage(state, action) {
      state.projectVariantChoiceStage = action.payload
    },

    setPopulation(state, action) {
      state.population = action.payload;
    },

    setNameEdit(state, action) {
      state.nameEdit = action.payload
    },

    setNameEditTarget(state, action) {
      state.nameEditTarget = action.payload
    },

    setLocations(state, action) {
      state.locations = action.payload
    },

    setBrainstormData(state, action) {
      state.brainstormData = action.payload
    },

    setTopPerformingConcepts(state, action) {
      state.topPerformingConcepts = action.payload
    }
  },

  extraReducers(builder) {
    builder.addCase(fetchMenu.fulfilled, (state, action) => {
      state.menu = action.payload.dashboard;
    });
  }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer, activeID, openProjectCreator, setProjectMenu, setConceptBeingEdited, setActiveMarket, setAllMarkets, setProjectId, setProjectName, setAllowRegionsReset, setIsSizeWelcome, setAllConcepts, setAvailableConcepts, setOpenedProjectName, setIsBrainstormWelcome, setOpenedProjectModules, setActiveStep, setIsAiGenerate, setSegments, setActiveSubstep, setDisplayedResponses, setModelConceptToShow, setDisplayData, setDisplayData2, setEmail, setLockSexQueryBecauseOfSegmentNameChange, setIsResponseLoading, setDisplayData2Original, setDisplayDataOriginal, setSpecialAllowRegionsReset, setNewExistingMarketAdding, setIsAnyStep2Behaviour, setProjectVariantChoiceStage, setPopulation, setNameEdit, setNameEditTarget, setLocations, setBrainstormData, setTopPerformingConcepts } = menu.actions;
